import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import FlightIcon from "@mui/icons-material/Flight";
import TrainIcon from "@mui/icons-material/Train";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

export const TRANSPORT_COLORS = {
  ocean: "#1E3A5F",
  air: "#7C3AED",
  ground: "#D97706",
} as const;

export const TRANSPORT_BACKGROUNDS = {
  ocean: "#EFF6FF",
  air: "#F5F3FF",
  ground: "#FFF7ED",
  rail: "#FFFBEB",
} as const;

export const TRANSPORT_ICON_COLORS = {
  ocean: TRANSPORT_COLORS.ocean,
  air: TRANSPORT_COLORS.air,
  ground: TRANSPORT_COLORS.ground,
  rail: TRANSPORT_COLORS.ground,
} as const;

export const TRANSPORT_META = {
  Ocean: {
    label: "Ocean",
    color: TRANSPORT_COLORS.ocean,
    bgColor: TRANSPORT_BACKGROUNDS.ocean,
    Icon: DirectionsBoatIcon,
  },
  Air: {
    label: "Air",
    color: TRANSPORT_COLORS.air,
    bgColor: TRANSPORT_BACKGROUNDS.air,
    Icon: FlightIcon,
  },
  Ground: {
    label: "Ground",
    color: TRANSPORT_COLORS.ground,
    bgColor: TRANSPORT_BACKGROUNDS.ground,
    Icon: LocalShippingIcon,
  },
  Rail: {
    label: "Rail",
    color: TRANSPORT_ICON_COLORS.rail,
    bgColor: TRANSPORT_BACKGROUNDS.rail,
    Icon: TrainIcon,
  },
} as const;

export const TRANSPORT_LINE_STYLES = {
  Ocean: {
    dashArray: "",
  },
  Air: {
    dashArray: "8, 6",
  },
  Ground: {
    dashArray: "6, 4",
  },
  Rail: {
    dashArray: "6, 4",
  },
} as const;
